import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  query GetDocumentsBySubject($courseId: String!, $subjectId: String!) {
    documents(courseId: $courseId, subjectId: $subjectId)
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
